import React from "react";
import { makeStyles } from "@material-ui/core";

import { AiFillCrown } from "react-icons/ai";

const useStyles = makeStyles(theme => ({
  container: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    color: theme.palette.common.white,
    background: "linear-gradient(180deg, #FF7B5A 0%, #5c4ee5 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 0
  }
}));

const PremiumIcon: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <AiFillCrown style={{ lineHeight: 0 }} />
    </div>
  );
};

export default React.memo(PremiumIcon);
